import clsx from 'clsx';

import transformToHTML5 from '@utils/html';

interface Props {
  html?: string;
  className?: string;
}

function RawHtml(props: Props) {
  const { html = '', className } = props;

  return (
    <div
      className={clsx('flow', className)}
      dangerouslySetInnerHTML={{ __html: transformToHTML5(html) }}
    />
  );
}

export default RawHtml;
